module.exports = __webpack_public_path__ + "static/media/burguerqueen.5c798ddb.png";